// extracted by mini-css-extract-plugin
export default {"section":"src-pages-Order-Components-Voucher-css-module__section--NADd9"};